
import { ActionButtonVariant } from '@/lib/colors';

// Size classes for different modal sizes
export const sizeClasses = {
  sm: 'md:max-w-[400px]',
  md: 'md:max-w-[550px]',
  lg: 'md:max-w-[700px]',
  xl: 'md:max-w-[900px]',
};

// Accent color gradient classes
export const accentColorClasses: Record<ActionButtonVariant, string> = {
  purple: 'from-brandPurple to-brandBlue',
  blue: 'from-blue-500 to-cyan-500',
  green: 'from-emerald-500 to-teal-500',
  amber: 'from-amber-500 to-yellow-500',
  red: 'from-red-500 to-rose-500',
  default: 'from-accent to-accent/80',
  vibrant: 'from-purple-500 to-blue-500',
  rose: 'from-rose-500 to-pink-500',
  indigo: 'from-indigo-500 to-violet-500',
  cyan: 'from-cyan-500 to-sky-500',
  documentation: 'from-blue-400 to-indigo-500',
  video: 'from-red-500 to-orange-500',
  link: 'from-blue-500 to-indigo-500',
  destructive: 'from-red-500 to-rose-500',
  fuchsia: 'from-fuchsia-500 to-pink-500',
  orange: 'from-orange-500 to-amber-500',
  pink: 'from-pink-500 to-rose-500',
  gray: 'from-gray-500 to-slate-500',
  slate: 'from-slate-500 to-gray-500',
  zinc: 'from-zinc-500 to-gray-500',
  neutral: 'from-neutral-500 to-gray-500',
  stone: 'from-stone-500 to-gray-500',
  emerald: 'from-emerald-500 to-teal-500',
  teal: 'from-teal-500 to-cyan-500',
  sky: 'from-sky-500 to-blue-500',
  violet: 'from-violet-500 to-purple-500'
};
